import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
// import axios from 'axios';
import { Helmet } from "react-helmet";

// components
//import Hero from '../components/Hero';

class Page extends Component {
  state = {
    isLoaded: false
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('#main').classList.add('hero');
  }

  handleClick = (e) => {
    e.preventDefault();
    let lnk = e.target.dataset.link;
    window.open(lnk,'_self');
  }

  render() {
    // const { appleLink, googleLink } = this.state;
    // console.dir(isLoaded);

    return (
      <>
      <Helmet>
        <link rel="canonical" href={ window.location.href } />
        <meta property="og:url" content={ window.location.href } />
      </Helmet>

     {/*  <Hero title="Housing Portal" campus="homepage" />
 */}
      <div className="homepage">
        <div className="container-fluid">
          <div className="row">

            <div className="container">
              <div className="row">

                <div className="col-12">
                  <h2>USAHS Students Roommate Request and Housing Information Portal</h2>
                  <p>Welcome to the USAHS Housing Portal. Currently, USAHS does not provide student housing but we do have several resources to support you in your search. Our housing portal will help you to find apartments recommended by your peers, classmates looking for roommates, private rental listings, and answers to frequently asked questions. Click your campus to get started.</p>
                </div>

                <div className="campus-wrap">
                  <div className="col-4 campusCont" onClick={ this.handleClick } data-link="/st-augustine">
                    <img src="/global/images/st-augustine.webp" alt="St. Augustine Campus" />
                    <p>St. Augustine, Florida</p>
                  </div>

                  <div className="col-4 campusCont" onClick={ this.handleClick } data-link="/miami">
                    <img src="/global/images/campus-flmi.jpg" alt="Miami Campus" />
                    <p>Miami, Florida</p>
                  </div>

                  <div className="col-4 campusCont" onClick={ this.handleClick } data-link="/austin">
                    <img src="/global/images/campus-txau.jpg" alt="Austin Campus" />
                    <p>Austin, Texas</p>
                  </div>
                </div>
                <div className="campus-wrap">

                  <div className="col-4 campusCont" onClick={ this.handleClick } data-link="/dallas">
                    <img src="/global/images/campus-txda.jpg" alt="Dallas Campus" />
                    <p>Dallas, Texas</p>
                  </div>

                  <div className="col-4 campusCont" onClick={ this.handleClick } data-link="/san-marcos">
                    <img src="/global/images/campus-casm.jpg" alt="San Marcos Campus" />
                    <p>San Marcos, California</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      </>
    );
  }
}

export default Page;